var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 45.625C41.5396 45.625 45.625 41.5396 45.625 36.5C45.625 31.4604 41.5396 27.375 36.5 27.375C31.4604 27.375 27.375 31.4604 27.375 36.5C27.375 41.5396 31.4604 45.625 36.5 45.625Z",
    fill: "#8a3eb8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8335 12.1667H51.1914L47.4197 8.06046C46.2943 6.81337 44.6518 6.08337 42.9485 6.08337H30.0518C28.3485 6.08337 26.706 6.81337 25.5502 8.06046L21.8089 12.1667H12.1668C8.821 12.1667 6.0835 14.9042 6.0835 18.25V54.75C6.0835 58.0959 8.821 60.8334 12.1668 60.8334H60.8335C64.1793 60.8334 66.9168 58.0959 66.9168 54.75V18.25C66.9168 14.9042 64.1793 12.1667 60.8335 12.1667ZM36.5002 51.7084C28.1052 51.7084 21.2918 44.895 21.2918 36.5C21.2918 28.105 28.1052 21.2917 36.5002 21.2917C44.8952 21.2917 51.7085 28.105 51.7085 36.5C51.7085 44.895 44.8952 51.7084 36.5002 51.7084Z",
    fill: "#8a3eb8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9149c4b665d11d4d8151188228803f2d.svg";
export { ForwardRef as ReactComponent };